var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPhaseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.60194C0 0.717214 0.743447 0 1.66054 0H12.8171C13.2575 0 13.6799 0.168776 13.9913 0.469198L17.5136 3.86726C18.1621 4.49285 18.1621 5.50715 17.5136 6.13274L13.9913 9.5308C13.6799 9.83123 13.2575 10 12.8171 10H1.66054C0.743447 10 0 9.28279 0 8.39806V1.60194ZM1.66054 1.26214C1.466 1.26214 1.3083 1.41427 1.3083 1.60194V8.39806C1.3083 8.58573 1.466 8.73786 1.66054 8.73786H12.8171C12.9105 8.73786 13.0001 8.70206 13.0662 8.63834L16.5885 5.24028C16.7261 5.10758 16.7261 4.89242 16.5885 4.75972L13.0662 1.36166C13.0001 1.29794 12.9105 1.26214 12.8171 1.26214H1.66054Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPhaseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phase-icon.c55954eddd469f29500339512dffd037.svg";